/* eslint-disable */

import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import './SignIn_SignUpcss.css';
import 'sweetalert2/src/sweetalert2.scss';

import React, { Component, Suspense, lazy } from 'react';
import { Route, BrowserRouter as Router } from 'react-router-dom';

import $ from 'jquery';
import CryptoJS from 'crypto-js';
import GoogleLogin from 'react-google-login';
import { LoadingPage } from './LoadingPage';
import ReactDOM from 'react-dom';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import logomb from './image/tictokn40.png';
import useResetUrl from './CommonComponents/CommonComponents';

const SignIn = lazy(() => import('./SignIn'))
const VerificationMailSentMessage = lazy(() => import('./MessageDisplayPage'));
const ForgotPassword = lazy(() => import('./ForgotPassword'));
const LandingPage = lazy(() => import('./LandingPage'));
var encrypted;

class SignUp extends Component {

    constructor() {
        super()
        this.state = {
            formValid: false,
            signupFormValid: false,
            signUpFrom: '',
            signupUserName:'',
            signupFormErrors: { signupEmailId: '', signupPassword: '' },
            signupEmailIdValid: false,
            signupPasswordValid: false,
            signupUserNameValid: false,
        };
    }

    componentDidMount(){
        useResetUrl
    }
    handleUserInputSignUpname = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },
            () => { this.validateSignUpField(name, value) });
    }
    handleUserInputSignUpEmail = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.state.signUpFrom = "Text";
        this.setState({
            [name]: value
        },
            () => { this.validateSignUpField(name, value) });
    }

    handleUserSignUpPassword = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },
            () => { this.validateSignUpField(name, value) });
            
    }

    signin() {
        ReactDOM.render(
            <Router>
                <Suspense fallback={<LoadingPage />}>
                    <div >
                        <Route path="/" component={SignIn} />
                    </div>
                </Suspense>
            </Router>, document.getElementById('root'));

    }

    validateSignUpField(fieldName, value) {
        let fieldValidationErrors = this.state.signupFormErrors;
        let signupEmailIdValid = this.state.signupEmailIdValid;
        let signupPasswordValid = this.state.signupPasswordValid;
        let signupUserNameValid = this.state.signupUserNameValid;
        console.log("validateSignUpField is working");
        switch (fieldName) {
            case 'signupUserName':
                signupUserNameValid = value.length >= 5 && value.match(/^[A-Za-z]/);
                fieldValidationErrors.signupUserName = signupUserNameValid ? '' : ' is too short';
                break;
            case 'signupEmailId':
                signupEmailIdValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.signupEmailId = signupEmailIdValid ? '' : ' is invalid';
                break;
            case 'signupPassword':
                signupPasswordValid = value.length >= 5 && value.match(/^((?=.*[0-9])(?=.*[A-Z])(?=.{8,}))/);
                fieldValidationErrors.signupPassword = signupPasswordValid ? '' : ' is too short';
                break;
            default:
                break;
        }
        this.setState({
            signupFormErrors: fieldValidationErrors,
            signupEmailIdValid: signupEmailIdValid,
            signupPasswordValid: signupPasswordValid,
            signupUserNameValid: signupUserNameValid,
        }, this.validateSignUpForm);
    }

    validateSignUpForm() {
        this.setState({ signupFormValid: this.state.signupEmailIdValid && this.state.signupUserNameValid && this.state.signupPasswordValid });
        //  && this.state.signupPasswordValid
    }

    errorClass(error) {
        return (error.length == 0 ? '' : 'has-error');
    }
    Fpassword() {
        ReactDOM.render(< ForgotPassword />, document.getElementById('root'));

    }

    HomeFunc() {

        ReactDOM.render(
            <Router>
                <Suspense fallback={<LoadingPage />}>
                    <div >
                        <Route path="/" component={LandingPage} />

                    </div>
                </Suspense>
            </Router>
            , document.getElementById("root"));

    }

    SignUpFunc() {

        var self = this;

        if (this.state.signUpFrom == "Text") {
            this.state.firstName = this.state.signupUserName;
            this.state.lastName = "";
        }
        var key = "shinchanbaby";
        localStorage.setItem('EmailId', CryptoJS.AES.encrypt(this.state.signupEmailId, key));
	//	localStorage.setItem('Password', CryptoJS.AES.encrypt(encrypted, key));
        localStorage.setItem('FirstName', CryptoJS.AES.encrypt(this.state.firstName, key));
        localStorage.setItem('LastName', CryptoJS.AES.encrypt(this.state.lastName, key));
        var secret = "ShinchanThroughAppsShinchanThroughApps";
		encrypted = CryptoJS.AES.encrypt(this.state.signupPassword, secret);
		encrypted = encrypted.toString();
        localStorage.setItem('Password', CryptoJS.AES.encrypt(encrypted, key));
      

        $.ajax({
            type: 'POST',
            data: JSON.stringify({
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                emailId: this.state.signupEmailId,
                password: encrypted
            }),
           // url: "http://localhost:8080/EmployeeAttendenceAPI/SignUpActivities/SignUpWithOTP",
            url: serverUrl+"/EmployeeAttendenceAPI/SignUpActivities/SignUpWithOTP",

            contentType: "application/json",
            dataType: 'json',
            crossDomain: true,
            success: function (data, textStatus, jqXHR) {


                if (data.response == "Success") {

                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        text: "Verification code has been mailed to your "
                            + "authorized EmailId kindly verify your EmailId",
                        timer: 2000
                    });
                    console.log("data.otp ",data.otp)
                    localStorage.setItem('OTP', CryptoJS.AES.encrypt(data.otp.toString(), key));

                    ReactDOM.render(
                        <Router>
                            <Suspense fallback={<LoadingPage />}>
                                <div >
                                    <VerificationMailSentMessage emailId={self.state.signupEmailId} />
                                    
                                </div>
                            </Suspense>
                        </Router>, document.getElementById('root'));
                    self.state.signupEmailId = "";
                    self.state.firstName = "";
                    self.state.lastName = "";
                    self.state.signupPassword = "";

                    self.setState({
                        signupEmailId: self.state.signupEmailId,
                        signupPassword: self.state.signupPassword,
                        firstName: self.state.firstName,
                        lastName: self.state.lastName,
                    })

                } else if (data.response == "EmailId_AlreadyExist") {

                    Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        text: "You have already Regeistered with Tictoks",
                        timer: 2000
                    })
                }


            },
            error: function (data, textStatus, jqXHR) {

                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'No Internet',
                    text: 'Network Connection Problem',
                    timer: 2000
                })

            },

        });


    }
    show_Password() {
        var passwordInput = document.getElementById('password-field');
        var passStatus = document.getElementById('pass-status');

        if (passwordInput.type == 'password') {
            passwordInput.type = 'text';
            passStatus.className = 'fa fa-eye-slash';

        }
        else {
            passwordInput.type = 'password';
            passStatus.className = 'fa fa-eye';
        }
    }
    render() {


        const responseGoogle = async (response) => {
            console.log("RESPONSE GOOGLE :", response);

            if (response.error) {

                console.log("GOOGLE ERROR");
            } else if (response.profileObj.email != "") {

                this.state.firstName = response.profileObj.givenName;
                this.state.lastName = response.profileObj.familyName;
                this.state.signupEmailId = response.profileObj.email;
                this.state.signUpFrom = "Google";
                encrypted ="U2FsdGVkX19Iz9+nL7T1csE23Fi9+Ly5NYAEuzcZZi0=";

                //CALL THE SIGNUP FUNCTION
                this.SignUpFunc();

            }
        }

        return (
            <div class="container-fluid signupfont" style={{ backgroundColor: "" }}>
                <div className="row">
                    <div class="col-md-6" style={{ padding: "0px" }}>
                        <div class="signup_page_wrap">
                            <div class="signup_page">
                                <div class="old_account" style={{ marginTop: "10px" }}>
                                    <p class="logomb">
                                        {/* <img src={logomb} /> */}
                                        <span class="logotext">letzcheckin.com</span>
                                    </p>
                                </div>
                                <form className="Sign_Up_form">
                                    <div class="signup_title">
                                        <h3>Start your 7 days Free Trial</h3>
                                        <span class="small">Access to all features. No credit card required.</span>
                                    </div>
                                    <div class="text-center mt-10">
                                        <GoogleLogin
                                            clientId="543894373402-gmusj94l3obtrfvl273upb6o5lrvqrcd.apps.googleusercontent.com"
                                            buttonText="sign up with Google"
                                            className="goole_loginbtn"
                                            onSuccess={responseGoogle}
                                            onFailure={responseGoogle}
                                        />
                                        <h3 className="orsignin_cls"> or </h3>
                                    </div>
                                    <label>Full Name</label>
                                    <input type="name" value={this.state.signupUserName} onChange={this.handleUserInputSignUpname} className="form-control"
                                        name="signupUserName" id="name" required="" autoFocus="" placeholder="John Smith" />
                                    <label class="mt-top">Work Email</label>
                                    <input type="email" value={this.state.signupEmailId} onChange={this.handleUserInputSignUpEmail} className="form-control"
                                        name="signupEmailId" id="emailId" required="" autoFocus="" placeholder="name@example.com" />
                                    <div class="show_pwd">
                                        <label class="mt-top">Password</label>
                                        <input type="password" value={this.state.signupPassword}
                                            onChange={this.handleUserSignUpPassword} name="signupPassword"
                                            id="password-field" className="form-control" required="" placeholder="Choose a Password" /><i class="fa fa-eye" id="pass-status" aria-hidden="true" onClick={this.show_Password}></i>
                                        {!this.state.signupFormValid ? <span style={{ fontSize: "10px", color: "red" }}>Use atleast 8 characters, should have atleast one uppercase letter,one lower letter, a number and no space</span> : ""}
                                    </div>
                                    <button type="button" className="signIn_btn btn btn-primary" disabled={!this.state.signupFormValid} onClick={() => this.SignUpFunc()}  >Start My Free Trial</button>
                                </form>
                                <div class="text-center" style={{ marginTop: "10px" }}>
                                    <span class="term">By creating an account, you are agreeing to our <br /><a id="service" href="https://throughapps.com/terms-and-conditions/" target="_blank"><b>Terms of Service</b></a> and <a id="policy" href="https://throughapps.com/privacy-policy/" target="_blank"><b>Privacy policy</b></a></span>
                                    <p class="signup"><span>Already have an account?</span>
                                        <span class="btn-accn" onClick={this.signin}>Log In</span>
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 rightsidesignup" style={{ padding: "0px" }}>
                        <div class="rightside_img">
                        </div>


                    </div>

                </div>

            </div>
        );
    }
}

export default SignUp;

